import { CompiledQuery } from 'kysely';

export type Message =
  | { kind: 'SETUP'; blockchainWorkerPort: MessagePort }
  | { kind: 'RESET' }
  | { kind: 'CLEAR_ALL_DATA' }
  | { kind: 'CLEAR_ADDRESS_DATA' }
  | { kind: 'SANITY_CHECK' }
  | { kind: 'PING' }
  | { kind: 'PONG' }
  | { kind: 'QUERY'; query: CompiledQuery<unknown> };

export async function setup(blockchainWorkerPort: MessagePort) {
  return MessageBus.send(
    'databaseWorker',
    { kind: 'SETUP', blockchainWorkerPort },
    { expectReply: 'READY' },
  );
}

export async function query<
  Q extends CompiledQuery<unknown>,
  R = Q extends CompiledQuery<infer Result> ? Result : never,
>(q: Q) {
  try {
    const reply = await MessageBus.send(
      'databaseWorker',
      { kind: 'QUERY', query: q },
      { expectReply: 'QUERY_RESULT' },
    );
    return reply.result as readonly R[];
  } catch (error: unknown) {
    if (
      !!error &&
      typeof error === 'object' &&
      'error' in error &&
      typeof error.error === 'string'
    ) {
      throw new Error(`Query failed: ${error.error}`);
    }
    throw error;
  }
}

export async function queryRaw(sql: string) {
  return query({ sql } as unknown as CompiledQuery);
}

export async function clearAllData() {
  return MessageBus.send('databaseWorker', { kind: 'CLEAR_ALL_DATA' }, { expectReply: 'READY' });
}

export async function clearAddressData() {
  return MessageBus.send(
    'databaseWorker',
    { kind: 'CLEAR_ADDRESS_DATA' },
    { expectReply: 'READY' },
  );
}

export async function sanityCheck() {
  return MessageBus.send(
    'databaseWorker',
    { kind: 'SANITY_CHECK' },
    { expectReply: 'SANITY_CHECK_RESPONSE' },
  );
}

export async function ping() {
  return MessageBus.send('databaseWorker', { kind: 'PING' }, { expectReply: 'PONG' });
}
